/**
 * mobile-menu-fix.js
 * Load this AFTER main.js in theme.liquid:
 */

(function () {
  'use strict';

  // ─── Config ────────────────────────────────────────────────────────────────

  var SELECTORS = {
    burger:    '.snippet-main-menu-mobile-burger-menu-v2',
    container: '.snippet-main-menu-mobile-burger-menu-container',
    menu:      '.snippet-main-menu-mobile-content'
  };

  var CLASSES = {
    containerActive: 'snippet-main-menu-mobile-burger-menu-container-active',
    burgerActive:    'snippet-main-menu-mobile-burger-menu-change'
  };

  // px — above this breakpoint the mobile menu is hidden and state is reset
  var DESKTOP_BREAKPOINT = 1024;

  // ms — must match your CSS transition duration on the menu element
  var SLIDE_DURATION = 300;


  // ─── State ─────────────────────────────────────────────────────────────────

  var state = {
    isOpen:      false,  // current logical open/closed state
    isAnimating: false   // true while a slide animation is in flight
  };


  // ─── Element refs ──────────────────────────────────────────────────────────

  var burger;
  var container;
  var menu;


  // ─── Slide helpers (vanilla replacements for jQuery slideDown/slideUp) ─────

  /**
   * Animate an element open by expanding its height from 0 to its natural height.
   * Requires the element to have overflow:hidden in CSS.
   */
  function slideDown(el, duration, callback) {
    el.style.display    = 'block';
    el.style.overflow   = 'hidden';
    el.style.height     = '0px';
    el.style.transition = 'none';

    // Force a reflow so the browser registers the 0px starting height
    el.offsetHeight; // eslint-disable-line no-unused-expressions

    var targetHeight = el.scrollHeight + 'px';

    el.style.transition = 'height ' + duration + 'ms ease';
    el.style.height     = targetHeight;

    var onEnd = function () {
      el.removeEventListener('transitionend', onEnd);
      // Clean up inline styles — let CSS take over
      el.style.transition = '';
      el.style.height     = '';
      el.style.overflow   = '';
      if (typeof callback === 'function') callback();
    };

    el.addEventListener('transitionend', onEnd);
  }

  /**
   * Animate an element closed by collapsing its height to 0.
   */
  function slideUp(el, duration, callback) {
    el.style.overflow   = 'hidden';
    el.style.height     = el.scrollHeight + 'px';
    el.style.transition = 'none';

    // Force a reflow
    el.offsetHeight; // eslint-disable-line no-unused-expressions

    el.style.transition = 'height ' + duration + 'ms ease';
    el.style.height     = '0px';

    var onEnd = function () {
      el.removeEventListener('transitionend', onEnd);
      el.style.display    = 'none';
      el.style.transition = '';
      el.style.height     = '';
      el.style.overflow   = '';
      if (typeof callback === 'function') callback();
    };

    el.addEventListener('transitionend', onEnd);
  }

  /**
   * Cancel any in-flight CSS transition and snap to the closed state instantly.
   */
  function snapShut(el) {
    el.style.transition = 'none';
    el.style.height     = '';
    el.style.overflow   = '';
    el.style.display    = 'none';
  }


  // ─── Menu open / close / reset ─────────────────────────────────────────────

  function openMenu() {
    if (state.isAnimating || state.isOpen) return;

    state.isAnimating = true;

    container.classList.add(CLASSES.containerActive);
    burger.classList.add(CLASSES.burgerActive);

    slideDown(menu, SLIDE_DURATION, function () {
      state.isOpen      = true;
      state.isAnimating = false;
    });
  }

  function closeMenu() {
    if (state.isAnimating || !state.isOpen) return;

    state.isAnimating = true;

    slideUp(menu, SLIDE_DURATION, function () {
      container.classList.remove(CLASSES.containerActive);
      burger.classList.remove(CLASSES.burgerActive);
      state.isOpen      = false;
      state.isAnimating = false;
    });
  }

  /**
   * Hard-reset all visual state without animation.
   * Used when the viewport crosses the desktop breakpoint.
   */
  function resetMenu() {
    snapShut(menu);
    container.classList.remove(CLASSES.containerActive);
    burger.classList.remove(CLASSES.burgerActive);
    state.isOpen      = false;
    state.isAnimating = false;
  }


  // ─── Helpers ───────────────────────────────────────────────────────────────

  function isDesktopWidth() {
    return window.innerWidth >= DESKTOP_BREAKPOINT;
  }


  // ─── Resize handling ───────────────────────────────────────────────────────

  var resizeTimer;

  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (isDesktopWidth() && (state.isOpen || state.isAnimating)) {
        resetMenu();
      }
    }, 150);
  }


  // ─── Burger click ──────────────────────────────────────────────────────────

  function onBurgerClick(e) {
    e.preventDefault();

    // Ignore clicks mid-animation — first click wins
    if (state.isAnimating) return;

    if (state.isOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  }


  // ─── Strip legacy listeners & bind fresh ones ──────────────────────────────

  function init() {
    burger    = document.querySelector(SELECTORS.burger);
    container = document.querySelector(SELECTORS.container);
    menu      = document.querySelector(SELECTORS.menu);

    // Bail silently if the expected elements aren't on this page
    if (!burger || !container || !menu) return;

    // Clone the burger to strip any event listeners attached by main.js
    var freshBurger = burger.cloneNode(true);
    burger.parentNode.replaceChild(freshBurger, burger);
    burger = freshBurger; // update our ref to the new node

    burger.addEventListener('click', onBurgerClick);

    window.addEventListener('resize', onResize);

    // Snap to a clean initial state in case main.js left anything open
    resetMenu();
  }


  // ─── Boot ──────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOM already ready (script loaded with defer or at bottom of body)
    init();
  }

}());